import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const fetchMedicineStoresData = async () => {
  try {
    const response = await axios.get(`${BASE_URL}Lab`);

    console.log("✅ FULL API RESPONSE:", response.data);

    const data = Array.isArray(response.data)
      ? response.data
      : response.data?.data || [];

    // ✅ ONLY MEDICINE STORES
    const filteredStores = data.filter(
      (item) =>
        item.isMedicineStore === true ||
        item.isMedicineStore === "true"
    );

    return filteredStores.map((item) => {
      console.log("🏪 STORE:", item.lab_name);

      // ================= IMAGE FIX =================
      let imageUrl =
        "https://placehold.co/400x250?text=No+Image";

      if (item.lab_image && String(item.lab_image).trim() !== "") {
        const cleanImage = String(item.lab_image)
          .trim()
          .replace(/\s/g, "%20");

        // ✅ YOUR REQUIRED PATH (FIXED HERE)
        imageUrl = `https://online-tech.in/LabImage/${cleanImage}`;
      }

      console.log("🖼 FINAL IMAGE URL:", imageUrl);

      return {
        id: item.id,

        // STORE INFO
        name: item.lab_name || "Unnamed Store",
        phone: item.phone_no || "N/A",
        address: item.address || "",

        // IMAGE
        image: imageUrl,

        // LOCATION
        latitude: parseFloat(String(item.latitude || "").trim()),
        longnitude: parseFloat(String(item.longnitude || "").trim()),

        // FLAG
        isMedicineStore: item.isMedicineStore,
      };
    });
  } catch (error) {
    console.error("❌ Error fetching stores:", error);
    return [];
  }
};